import { LoyaltyAuthenticatedComponent } from './loyalty_authenticated.component';
import { LoyaltyAuthenticatedContainerComponent } from './loyalty_authenticated_container.component';
import { LoyaltyService } from './loyalty.service';

import './loyalty.scss';

export const LoyaltyModule = angular
    .module('oo.checkout.checkoutSteps.loyalty', [])
    .component('loyaltyAuthenticated', LoyaltyAuthenticatedComponent)
    .component('loyaltyAuthenticatedContainer', LoyaltyAuthenticatedContainerComponent)
    .service('loyaltyService', LoyaltyService)
    .name;
